export const ButtonHeaderAddComponent = {
  bindings: {},
  transclude: true,
  templateUrl: 'components/Buttons/button-header-add/button-header-add.html',
};
